import React from 'react';
import { classNames } from '@/utils/classNames';

interface PaginationInfoProps {
  currentPage: number;
  totalPages: number;
  startIndex: number;
  endIndex: number;
  totalItems: number;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
}

export const PaginationInfo: React.FC<PaginationInfoProps> = ({
  currentPage,
  totalPages,
  startIndex,
  endIndex,
  totalItems,
  className,
  size = 'md',
}) => {
  const sizeClasses = {
    sm: 'text-xs',
    md: 'text-sm',
    lg: 'text-base',
  };

  if (totalItems === 0) {
    return (
      <div className={classNames('text-gray-500 dark:text-gray-400', sizeClasses[size], className)}>
        データがありません
      </div>
    );
  }

  return (
    <div
      className={classNames(
        'flex items-center gap-4 text-gray-600 dark:text-gray-400',
        sizeClasses[size],
        className
      )}
    >
      <span className='whitespace-nowrap'>
        {startIndex.toLocaleString()}-{endIndex.toLocaleString()} / 全{totalItems.toLocaleString()}
        件
      </span>
      <span className='whitespace-nowrap'>
        ページ {currentPage} / {totalPages}
      </span>
    </div>
  );
};
